module.exports = __webpack_public_path__ + "static/img/escaparatismo.46c8327.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/proyectos_comerciales_secciones/escaparatismo.jpg
// module id = s0Tx
// module chunks = 1